'use client';

import { useState } from 'react';
import PricingToggle from './pricing-toggle';
import PricingCard from './pricing-card';
import { motion } from 'framer-motion';

export default function Pricing() {
  const [isYearly, setIsYearly] = useState(false);

  return (
    <section
      id="pricing"
      className="py-20 md:py-32 bg-gradient-to-b from-white to-zinc-50 dark:from-black dark:to-zinc-950 relative"
    >
      {/* Purple gradient background */}
      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[300px] opacity-20 blur-[100px] pointer-events-none"
        style={{
          background:
            'radial-gradient(circle at center, rgba(77, 46, 245, 0.3), rgba(125, 81, 237, 0.1), transparent)',
        }}
        aria-hidden="true"
      />

      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <motion.div
            className="text-center mb-12"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-zinc-900 dark:text-white mb-6">
              Gain your edge today
            </h2>
            <p className="text-xl text-zinc-600 dark:text-zinc-400 max-w-3xl mx-auto">
              Get the knowledge and edge you need to grow your wealth - today.
            </p>
          </motion.div>

          <motion.div
            className="mb-16 text-center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <PricingToggle onChange={setIsYearly} />
          </motion.div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <PricingCard
              title="Pro Plan"
              description="Perfect for individual investors"
              price={{ monthly: 49, yearly: 479.88 }}
              features={[
                '120 AI prompts per month',
                'Export charts and data',
                'Large & Mid & Small cap screening',
                '10 years historical data',
                'Ad-free experience',
              ]}
              isYearly={isYearly}
            />

            <PricingCard
              title="Investor Plan"
              description="For serious investors and professionals"
              price={{ monthly: 99, yearly: 959.88 }}
              features={[
                '500 AI prompts per month',
                'Unlimited historical data',
                'Micro-cap stock screening',
                'Historical earnings data',
                'Unlimited saved filters',
                'Priority support',
                'Future Release Early Access',
              ]}
              isYearly={isYearly}
              isPopular={true}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
